import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';
import transparentBeforeAnimation from '../lib/transparent-before-animation';
import { gsap } from '../vendor/gsap';
import { ScrollTrigger } from '../vendor/gsap/ScrollTrigger';
import addTranslateYAnimation from '../lib/add-translate-y-animation';

Swiper.use([Navigation]);
gsap.registerPlugin(ScrollTrigger);

const sectionSelector = '.culture-page-gallery-section';
// eslint-disable-next-line no-unused-vars
const sectionCallBack = (sectionElement, query, queryAll) => {
    const carousel = query('.culture-slider');
    const carouselPrev = query('.culture-slider-button-prev');
    const carouselNext = query('.culture-slider-button-next');
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: sectionElement,
            start: 'top 100%',
        },
    });
    transparentBeforeAnimation(carousel, timeline);
    addTranslateYAnimation(timeline, carousel, 0.1);
    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper(carousel, {
        modules: [Navigation],
        speed: 500,
        slidesPerView: 1,
        loop: true,
        observer: true,
        observeParents: true,
        navigation: {
            prevEl: carouselPrev,
            nextEl: carouselNext,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
        },
    });
};

export { sectionSelector, sectionCallBack };
